import * as React from 'react'

export default () => (
  <svg width="4" height="12" viewBox="0 0 4 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.875" y="0.375" width="2.25" height="6.75" fill="#EB5757" />
    <rect x="0.875" y="9.375" width="2.25" height="2.25" fill="#EB5757" />
  </svg>
)
